import RepositoryBase from "./repositoryBase";
import Enumerations from "entities/enumerations";

export default class EnumsRepository extends RepositoryBase {
  getEnums() {
    return this.callApi(api => api.all("enumerations").getEntity(Enumerations));
  }
}
